import { TemplateEngine } from "../../../../../js/lib/TemplateEngine";
import { TLCLogger } from "../../../../../js/lib/logger";
import { LS2PAC_CONSTANTS } from "../../../../../js/main/constants";
import { LibraryThing } from "../../widget/LibraryThingWidget";

export class BaseDetailView {
  constructor(options) {
    options = options || {};

    this.id = options.id;

    this.parentId =
      options.parentId ||
      LS2PAC_CONSTANTS.Ids.DetailsPage.fullDetails_subViewContainer;
    //this.databaseConfig = options.databaseConfig;
    this.hasBoundEvents = false;
    this.isActive = false;
    this.searchResponse = null;

    this.resultsTemplate = options.resultsTemplate;
    this.viewName = options.viewName;

    this.isDefault = options.isDefault;
  }
  refreshSUMetaData(selector, metaData, successCallback) {
    LibraryThing.addTOSLink($("#" + this.id)); // only adds if it doesn't exist already

    var target = $(selector);
    $(target).spin("small");

    var retryCallback = function () {
      TLCLogger.log("retrying metaData:", metaData);
      BaseDetailView.prototype.refreshSUMetaData(
        selector,
        metaData,
        successCallback
      );
    };

    var _this = this;
    $.when(LibraryThing.refreshMetaData(selector, metaData, retryCallback))
      .done(function (enrichmentsShown) {
        if (successCallback) {
          successCallback(enrichmentsShown);
        }
      })
      .always(function () {
        $(target).spin(false);
        if (_this.parentClass) {
          _this.parentClass.updatePagingControls();
        }
      });
  }
  addListeners() {}
  hide() {
    $("#" + this.id).hide();
  }
  show() {
    $("#" + this.id).show();
  }
  isCurrentView(viewNameToTest) {
    if (
      (!viewNameToTest && this.isDefault) ||
      viewNameToTest == this.viewName
    ) {
      return true;
    }
    return false;
  }
  setData(resourceData, index, viewName, parentClass) {
    var _this = this;
    this.resourceData = resourceData;
    this.index = index;
    this.parentClass = parentClass;

    this.currentResource = this.resourceData.resources[this.index];
    if (this.isCurrentView(viewName)) {
      if ($("#" + this.id).length == 0) {
        TemplateEngine.fetch(
          this.resultsTemplate,
          this.parentId,
          this.currentResource,
          function () {
            _this.load();
          }
        );
      } else {
        this.show();
        this.load();
      }
    } else {
      this.hide();
    }
  }
}
